import React, {useState} from 'react';
import Joi from 'joi';
import {AutocompleteSelect, AutoField} from 'components/forms/fields';
import EndSection from 'components/forms/EndSection';
import useFieldData from 'components/forms/hooks/useFieldData';
import {Typography} from '@material-ui/core';
import fields from 'components/forms/nvic/fields';
import {useGetNVIC} from 'hooks';
import schemas from '../fields/definedSchemas';
import Show from 'components/utils/Show';
import {SiteUrls} from '../../../constants';

const schema = {
    nvic_name: Joi.object().messages({
        'object.base': 'Please select an NVIC from the list.',
    }),
    nvic_completed: Joi.boolean().required(),
    completed_date: Joi.when(Joi.ref('nvic_completed'), {
        is: true,
        then: schemas.dateRequiredMaxToday.validation,
        otherwise: Joi.string().allow(''),
    }),
    assessor_info_completed: Joi.string().allow(''),
};

const initialValues = {
    nvic_name: '',
    nvic_completed: '',
    completed_date: '',
    assessor_info_completed: '',
};

const sanitizeNVIC = data => {
    const {
        //id_number_type,
        user_document_post_response,
        nvic_name,
        nvic_completed,
        completed_date,
        assessor_info_completed,
    } = data;

    return {
        nvic_id: nvic_name.id,
        nvic_completed,
        completed_date,
        assessor_info_completed,
        user_document_id: user_document_post_response?.user_document?.id,
    };
};

const NVIC = props => {
    const {data: nvics, isLoading: areNVICSLoading} = useGetNVIC();
    const [, setSelectedNVIC] = useState(null);
    const [completed, setCompleted] = useFieldData('nvic_completed');

    const nvicsFilter = nvics?.filter(
        item => !item?.assessed_task_name?.includes('Towing')
    );

    const updateCompleted = e => {
        setCompleted(e.currentTarget.value);
    };

    const showCompleted = completed === true || completed === 'true';

    return (
        <EndSection
            {...props}
            {...{schema, initialValues}}
            endpointOverride='nvic'
            sanitizeFunction={sanitizeNVIC}
            redirectUrl={SiteUrls.TRAINING}
            gridify
        >
            <Typography variant='h6' align='left'>
                NVIC Info
            </Typography>
            <Typography variant='body1'>
                Let's enter the information about this NVIC.
            </Typography>
            <AutocompleteSelect
                required
                name='nvic_name'
                label={fields.nvic_name.label}
                options={nvicsFilter || []}
                loading={areNVICSLoading}
                getOptionLabel={option => option?.assessed_task_name}
                onChangeListener={setSelectedNVIC}
                noOptionsText='No options, please enter at least 3 characters of the NVIC name'
            />
            <AutoField
                field={fields.nvic_completed}
                name='nvic_completed'
                onChange={updateCompleted}
            />
            <Show condition={showCompleted}>
                <AutoField
                    field={fields.completed_date}
                    name='completed_date'
                />
                <AutoField
                    field={fields.assessor_info_completed}
                    name='assessor_info_completed'
                />
            </Show>
            {props.children}
        </EndSection>
    );
};

export default NVIC;
export {sanitizeNVIC};
